import { Box } from "@whoosh/design-system/src/components/primitive/Box/Box";

export const UnselectedCircle = () => {
  return (
    <Box
      width={20}
      height={20}
      style={{ borderRadius: 20 }}
      borderWidth={1}
      borderColor="outline-default"
    />
  );
};

export const SelectedCircle = () => {
  return (
    <Box
      width={20}
      height={20}
      style={{ borderRadius: 20 }}
      borderWidth={1}
      borderColor="outline-main-primary"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        width={10}
        height={10}
        style={{ borderRadius: 10 }}
        backgroundColor="outline-main-primary"
      />
    </Box>
  );
};
